(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amazon-offer-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('koorui-amazon-offer')) {
    customElements.define('koorui-amazon-offer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const trigger = this.querySelector('[data-amazon-offer-trigger]');
        const dialog = this.querySelector('dialog');
        if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
        const copy = dialog.querySelector('[data-offer-copy]');
        const copyText = dialog.querySelector('[data-copy-text]');
        const status = dialog.querySelector('[data-offer-status]');
        trigger.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          copyText.textContent = copy.dataset.copyLabel;
          status.textContent = '';
          dialog.showModal();
          trigger.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('koorui-offer-open');
        }, options);
        dialog.querySelector('[data-offer-close]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          trigger.setAttribute('aria-expanded', 'false');
          if (!document.querySelector('.koorui-offer-dialog[open]')) document.documentElement.classList.remove('koorui-offer-open');
          trigger.focus({ preventScroll: true });
        }, options);
        copy.addEventListener('click', async () => {
          const value = dialog.querySelector('[data-offer-code]').textContent.trim();
          let copied = false;
          try {
            if (navigator.clipboard?.writeText) {
              await navigator.clipboard.writeText(value);
              copied = true;
            }
          } catch {}
          if (!copied) {
            const field = document.createElement('textarea');
            field.value = value;
            field.readOnly = true;
            field.style.cssText = 'position:fixed;left:0;top:0;opacity:0;font-size:16px;';
            dialog.append(field);
            field.select();
            try { copied = document.execCommand('copy'); } catch {}
            field.remove();
            copy.focus({ preventScroll: true });
          }
          copyText.textContent = copied ? copy.dataset.copiedLabel : copy.dataset.copyLabel;
          status.textContent = copied ? copy.dataset.copiedLabel : copy.dataset.copyError;
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (!document.querySelector('.koorui-offer-dialog[open]')) document.documentElement.classList.remove('koorui-offer-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
